export default __webpack_public_path__ + "components/weather-icon/static/nightdrizzle-9c63feaf2a884bcd21d2e50ec64afbef.svg";